import penpal from 'penpal';

import { container } from '@/app-modules/_ioc';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { User } from '@/app-modules/store/modules/user';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

export interface IParentFrameOptions {
  url: string;
  methods: any;
  appendTo?: HTMLElement;
}

export interface IParentFrameAdditionalOptions {
  url: string;
  frameId: string;
  clubId?: number;
}

export class ParentFrame {
    public iFrameID: string;
    public childFrameMethods?: any;
    public connection?: any;
    private options: IParentFrameOptions;

    constructor(iFrameID: string, frameMethods: any, options: IParentFrameAdditionalOptions) {
        this.options = {
            methods: frameMethods,
            url: this.buildUrlForChildFrame(options)
        };

        this.iFrameID = iFrameID;
    }

    public connectToChild(element: HTMLDivElement): Promise<void> {
        this.options.appendTo = element;
        this.connection = penpal.connectToChild(this.options);

        if (this.connection !== undefined) {
            this.connection.iframe.allow = 'autoplay';
            this.connection.iframe.style.display = 'none';
            this.connection.iframe.id = this.iFrameID;
        }

        return this.connection.promise.then((childMethods: any) => {
            this.childFrameMethods = childMethods;
        }).catch((error: Error) => {
            // eslint-disable-next-line
            console.log(`[Penpal] ${this.iFrameID} ${error}`);
        });
    }

    public destroy(): void {
        if (!this.connection) {
            return;
        }

        this.connection.destroy();
    }

    private buildUrlForChildFrame(options: IParentFrameAdditionalOptions): string {
        const splitUrl: string[] = options.url.split('?');
        const baseUrl: string = splitUrl[0];
        const search: string = splitUrl[1];
        const params: any = (search === undefined) ? {} : search
            .split('&')
            .map((p) => p.split('='))
            .reduce((obj, [key, value]) => ({...obj, [key]: value}), {});
        const persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
        const user = persistedStore.Get(User);

        params.userId = user.userId;
        params.crossCheck = user.crosscheckId;
        params.frameId = options.frameId;
        if (options.clubId) {
            params.clubNo = options.clubId;
        }

        const encodedParams = Object
            .entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
            .join('&');

        return `${baseUrl}?${encodedParams}`;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/iframes/parent-frame.ts